<template>
  <div class="checkoutTimeSelection">
    <div class="checkoutTimeSelection__header">
      <span class="checkoutTimeSelection__header-title">Выбор расчетного часа</span>
    </div>

    <div class="checkoutTimeSelection__body">
      <div class="checkoutTimeSelection__body-selection">
        <div
          v-for="item in checkoutTime"
          :key="item?.id"
          class="item"
          :class="{active: item?.active}"
          @click="changeCheckoutTime(item.id)"
        >
          <div class="item__top">
            <v-icon>{{item?.icon}}</v-icon>
            <span class="item__top-title">{{item?.title}}</span>
            <v-icon v-if="item?.active" class="check">$check</v-icon>
          </div>

          <div class="item__middle" v-if="item?.hideTime !== true">
            <div class="item__middle-datein">
              <v-icon>$carRight</v-icon>
              <span class="desc">
                {{dateIn}}, {{item?.timeIn}}
              </span>
            </div>

            <div class="item__middle-dateout">
              <v-icon>$carLeft</v-icon>
              <span class="desc">
                {{dateOut}}, {{item?.timeOut}}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="checkoutTimeSelection__footer" v-if="checkoutTimeActive === anyTimeZdrId">
      Если гость не определился с расчетным часом, то время заезда будет считаться по "основному расчетному часу".
    </div>
  </div>
</template>

<script>
import {mapActions, mapGetters, mapMutations, mapState} from "vuex";

export default {
  name: "checkoutTimeSelection",
  data: () => ({
    checkoutTime: [],

    cureSpaId: 3,
    anyTimeZdrId: 0,
    defaultCheckoutTimeZdrId: 3
  }),
  mounted() {
    this.setCheckoutTime()
  },

  watch: {
    typeCure() {
      this.setCheckoutTime()
    }
  },

  computed: {
    ...mapState({
      storeCheckoutTime: state => state.selection.checkoutTime,
    }),

    ...mapGetters({
      getGuestsFields: 'guestsModule/getGuestsFields',
      getCommonField: 'guestsModule/getCommonField'
    }),

    dateIn() {
      const arrDateIn = this.$store.state.selection?.dateIn?.split('-')
      return `${arrDateIn[2]}.${arrDateIn[1]}.${arrDateIn[0]}`
    },

    dateOut() {
      const arrDateOut = this.$store.state.selection?.dateOut?.split('-')
      return `${arrDateOut[2]}.${arrDateOut[1]}.${arrDateOut[0]}`
    },

    checkoutTimeActive() {
      return +this.checkoutTime?.find(item => item?.active === true)?.zdrId
    },

    /*Предполагается что в списке лечений только - "спа" (у всех гостей одинаковое лечение)*/
    typeCure() {
      return this.getCommonField('cure')
    },

    defaultCheckoutTimeId() {
      // return this.checkoutTime?.find(item => +item?.zdrId === this.defaultCheckoutTimeZdrId)?.id
      return this.checkoutTime?.find(item => +item?.default === true)?.id
    },

    selectedCheckoutTime: {
      get() {
        return this.storeCheckoutTime
      },
      set(v) {
        this.storeSetCheckoutTime(v)
      }
    }
  },
  methods: {
    ...mapMutations({
      storeSetCheckoutTime: `selection/setCheckoutTime`,
    }),

    ...mapActions({
      storeCalcGuestPrice: 'guestsModule/calcGuestPrice',
    }),

    setCheckoutTime() {
      this.checkoutTime = this.$store.state.dictionaries?.checkoutTime

      if(+this.typeCure === this.cureSpaId) {
        if(this.checkoutTimeActive === this.anyTimeZdrId)
          this.changeCheckoutTime(this.defaultCheckoutTimeId)

        this.checkoutTime = this.checkoutTime?.filter(item => +item?.zdrId !== this.anyTimeZdrId)
      }
    },

    changeCheckoutTime(id) {
      if(!id) return

      let selectedCheckoutTimeObj = this.checkoutTime.find(item => item.id === id)
      if(+selectedCheckoutTimeObj.zdrId === +this.anyTimeZdrId) {
        selectedCheckoutTimeObj = this.checkoutTime.find(item => item.default === true)
      }
      this.selectedCheckoutTime = selectedCheckoutTimeObj

      // this.checkoutTimeValue = id
      this.checkoutTime.forEach(item => item.active = item?.id === id)
      this.recalculatePrice()
    },

    recalculatePrice() {
      const guests = this.getGuestsFields(['id', 'guestType'])?.filter(guest => +guest?.type !== 2)
      if(guests.lenght === 0) return
      guests.forEach((guest) => {
        this.storeCalcGuestPrice(guest.id)
      })
    },

    validate() {
      return this.checkoutTime?.findIndex(item => item?.active === true) !== -1
    },
  }
}
</script>

<style lang="sass">
  .checkoutTimeSelection
    margin:
      top: 10px
      bottom: 40px

    &__header
      &-title
        display: block
        margin-bottom: 20px
        font:
          size: 1.125em
          weight: 700
        color: #1A4745

    &__body
      display: inline-block
      margin-bottom: 20px

      &-selection
        display: flex

        .item:first-child
          border-top-left-radius: 25px
          border-bottom-left-radius: 25px

        .item:last-child
          border-top-right-radius: 25px
          border-bottom-right-radius: 25px
          min-width: calc(165px + 6vw)

        .item.active
          background: #ECFAFB
          border-color: #248983

        .item:hover
          cursor: pointer

        .item
          padding: 20px 3vw
          border: 1px solid #8A8A8A
          background: #F2F2F2

          &__top
            margin-bottom: 10px

            &-title
              margin-left: 10px
              margin-right: 10px

            .check svg
              width: 15px
              height: 15px

          &__middle
            &-datein .desc,
            &-dateout .desc
              margin-left: 10px
              font-size: 0.75em
              color: #696D74

    &__footer
      font:
        size: 1em
        weight: 400
      color: #C01717

  @media screen and (max-width: $mobile-breakpoint)
    .checkoutTimeSelection

      &__body
        margin-left: auto

        &-selection
          flex-wrap: wrap

          .item:first-child
            border-top-left-radius: 25px
            border-bottom-left-radius: 0

          .item:last-child
            border-top-right-radius: 0
            border-bottom-right-radius: 25px
            min-width: auto

          .item:nth-child(2)
            border-top-right-radius: 25px

          .item:nth-child(3)
            border-bottom-left-radius: 25px

          .item
            width: 50%
            padding: 10px 15px
</style>
